module.exports = __webpack_public_path__ + "static/media/GoalsImage1.9ce4a16e.png";